import type { AdviceFilterCard } from '../types/inspirationAdviceFilter.types';

type CardType = 'advice' | 'tip';

const tipCardsIterationCount = 5;

const getItemsByType = (object: AdviceFilterCard[], type: CardType) =>
  object.filter(value => value.cardTypeOption === type);

export const filterAdviceItemsObject = (
  allAdviceItems: AdviceFilterCard[],
  filterTags: Record<string, string>,
  visibleItemsCount: number,
) => {
  const filteredAdviceItems = allAdviceItems.filter(value =>
    Object.values(filterTags).every(elem => value.tagsList?.some(tag => tag.itemName?.includes(elem))),
  );

  const adviceItems = Object.keys(filterTags).length ? Object.values(filteredAdviceItems) : allAdviceItems;

  const arrAdvice = getItemsByType(adviceItems, 'advice');
  const arrTip = getItemsByType(adviceItems, 'tip');

  let indexTip = -1;

  arrTip.forEach((element, index) => {
    indexTip += tipCardsIterationCount;

    if (index === 0) {
      arrAdvice.splice(tipCardsIterationCount - 1, 0, element);
    } else {
      arrAdvice.splice(indexTip, 0, element);
    }
  });

  return {
    filteredAdviceCards: arrAdvice.slice(0, visibleItemsCount),
    maxAmtOfCards: arrAdvice.length,
  };
};
